import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  Card,
  Typography,
  CardBody,
  CardFooter,
  Avatar,
  IconButton,
} from "@material-tailwind/react";
import moment from "moment";
import { AllBookingList } from "../../store/BookingSlice";
import { AllBookingLists } from "../../interfaces/BookingList";

const TABLE_HEAD = [
  "Title",
  "Name",
  "Amount",
  "Booking Date",
  "Acknowledgement Number",
];

const ListView = () => {
  const dispatch = useDispatch<any>();

  // const [currentPage, setCurrentPage] = useState(1);  
  // const itemsPerPage = 10;


  useEffect(() => {
      // Dispatch the fetchHealthData action to fetch health data
      dispatch(AllBookingList());
    }, [dispatch]);

    // Extract program IDs from userBookings array
    
    const BookingAll = useSelector((state: RootState) => {
      const bookingData = state.booking.data;
      if (!bookingData) {
        return [] as unknown as AllBookingLists[]; // Convert to unknown first
      }
      const convertedData = bookingData as unknown as AllBookingLists[];
      return convertedData;
    });
    
    
   
  // const handlePagination = (page: number, limit: number) => {
  //   dispatch(AllBookingList({ page, limit }));
  // };

  // const handleNextClick = () => {
  //   const nextPage = currentPage + 1;
  //   setCurrentPage(nextPage);
  //   handlePagination(nextPage, itemsPerPage);
  // };

  // const handlePreviousClick = () => {
  //   if (currentPage > 1) {
  //     const previousPage = currentPage - 1;
  //     setCurrentPage(previousPage);
  //     handlePagination(previousPage, itemsPerPage);
  //   }
  // };


  return (
    <>
      <div className=" bg-white  pb-2.5 sm:px-7.5 xl:pb-8 h-[calc(100vh-190px)] overflow-y-hidden">
        <div className="max-w-full overflow-x-auto">
          <Card className="h-full w-full">
          <CardBody className="overflow-hidden px-6  min-h-[550px]">
             <div className="max-h-[500px] w-full overflow-y-auto">
                <table className="w-full table-auto mb-4 ">
                  <thead>
                    <tr className="bg-gray-2 text-left border-b-2">
                      {TABLE_HEAD.map((head) => (
                        <th
                          key={head}
                          className="min-w-[150px] py-4 px-4 font-bold text-[#7E8299] uppercase cursor-pointer"
                        >
                          <div className="flex items-center">
                            <Typography
                              variant="small"
                              className="font-semibold leading-none text-[#7E8299] opacity-70"
                            >
                              {head}
                            </Typography>
                            <span className="ml-1"></span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                  {BookingAll?.map((booking) => (
                      <tr key={booking.id} className="border-b">
                      <td className="p-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {booking?.program?.title}
                          </Typography>
                        </td>
                        <td className="p-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {booking.patient.fullName}
                          </Typography>
                        </td>
                        
                      
                        <td className="p-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {"$ " + booking.amount}
                          </Typography>
                        </td>
                        
                        <td className="p-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {moment(booking.paymentDate).format(
                              "DD MMM, YYYY"
                            )}
                          </Typography>
                        </td>
                        <td className="p-4">
                          <Typography
                            variant="small"
                            color="black"
                            className="font-medium"
                          >
                            {booking.paymentReferenceId}
                          </Typography>
                        </td>
                              
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> 
            </CardBody>
            {/* <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 mx-6 p-4">
              <div className="flex float-right ml-auto items-center gap-2">
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={handlePreviousClick}
                  disabled={currentPage === 1}
                  className={`disabled:cursor-not-allowed ${
                    currentPage === 1 ? "text-gray-500" : ""
                  }`}
                >
                  Previous
                </Button>
                <IconButton
                  variant="outlined"
                  size="sm"
                  className="flex justify-center items-center cursor-default"
                >
                  {currentPage}
                </IconButton>
                <Button
                  variant="outlined"
                  onClick={handleNextClick}
                  disabled={currentPage + 1 > booking?.length}
                  size="sm"
                  className={`disabled:cursor-not-allowed disabled:text-gray-500`}
                >
                  Next
                </Button>
              </div>
            </CardFooter> */}
          </Card>
        </div>
      </div>
    </>
  );
};

export default ListView;
